import { AfterContentInit, AfterViewChecked, AfterViewInit, Injectable, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AccountService, HttpCommonService, LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { Subject } from "rxjs";
import { AppInjector } from "../../shared.module";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class BaseService implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit, AfterContentInit {
  protected ngUnsubscribe = new Subject<void>();
  protected dialogService: SimpleModalService;
  protected translateText: TranslateService;
  protected httpCommonService: HttpCommonService;
  protected accountService: AccountService;
  protected storage: LocalStoreManager;
  public formGroup: UntypedFormGroup;
  public isMultiBranch: boolean;
  constructor() {
    this.dialogService = AppInjector.get(SimpleModalService);
    this.translateText = AppInjector.get(TranslateService);
    this.httpCommonService = AppInjector.get(HttpCommonService);
    this.accountService = AppInjector.get(AccountService);
    this.storage = AppInjector.get(LocalStoreManager);
    const info = this.accountService.authService.currentInformation();
    this.isMultiBranch =
      (info?.BranchingAdvancedEnabled || info?.BranchingLightEnabled || info?.RestaurantCallCenter) &&
      this.accountService.authService.currentBranch?.AccessToAllBranches;
  }
  public get sts() {
    return AppInjector.get(ShowToastrService);
  }
  ngOnInit() {}
  translate(str: string): string {
    return this.translateText.instant(str);
  }
  ngAfterViewChecked(): void {}
  ngAfterViewInit() {}
  ngAfterContentInit() {}
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
  setValue(key: string, value: any, requiredvalidator: boolean = false, validator?: ValidatorFn) {
    if (!this.formGroup) {
      let newGroup = {};
      this.formGroup = new UntypedFormGroup(newGroup);
    }
    if (this.formGroup) {
      if (!this.formGroup.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
      else this.formGroup.controls[key].setValue(value);
    }
    if (requiredvalidator && this.formGroup && this.formGroup.controls[key]) this.formGroup.controls[key].setValidators(Validators.required);
    if (validator && this.formGroup && this.formGroup.controls[key]) this.formGroup.controls[key].setValidators(validator);
  }
}
